// A simple utility to help with list refreshing coordination

class RefreshManager {
  constructor() {
    this.listeners = {};
  }

  // Register a callback for a specific list type
  subscribe(listType, callback) {
    if (!this.listeners[listType]) {
      this.listeners[listType] = [];
    }
    this.listeners[listType].push(callback);
    
    // Return unsubscribe function
    return () => {
      this.listeners[listType] = this.listeners[listType].filter(cb => cb !== callback);
    };
  }

  // Trigger refresh for a specific list type
  triggerRefresh(listType) {
    if (this.listeners[listType]) {
      this.listeners[listType].forEach(callback => callback());
    }
  }

  // Trigger refresh for all list types
  triggerRefreshAll() {
    Object.keys(this.listeners).forEach(listType => {
      this.triggerRefresh(listType);
    });
  }
}

export default new RefreshManager();
